module.exports = __webpack_public_path__ + "media/images/teams/BOLOGNA-a9d22f436510266906c7bc91c54d0a6a.png";